const tableTitleFrequency = {
  title: 'Frequencies',
  placeholder: 'Search',
  Typography: 'no results found'
};

export default tableTitleFrequency;
